import React from 'react';
import { COMPANY_NAME } from '../constants';

const NotFoundPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-gray-800 p-4">
      <div className="text-center">
        <h1 className="text-8xl sm:text-9xl font-bold text-emerald-500 mb-4 tracking-tight">404</h1>
        <h2 className="text-3xl sm:text-4xl font-semibold text-gray-700 mb-6">Oops! Page Not Found.</h2>
        <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
          The page you are looking for might have been removed, had its name changed,
          or is temporarily unavailable.
        </p>
        <a
          href="/"
          className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-3 px-8 rounded-lg text-lg transition duration-300 ease-in-out transform hover:scale-105 shadow-md focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-opacity-75"
          aria-label="Go to Homepage"
        >
          Go to Homepage
        </a>
      </div>
      <footer className="absolute bottom-8 text-gray-500 text-sm">
        &copy; {new Date().getFullYear()} {COMPANY_NAME}. All rights reserved.
      </footer>
    </div>
  );
};

export default NotFoundPage;